<div *ngFor="let selectedUser of FollowFollowingList" class="user-card mat-elevation-z2">
    <div class="user-info">
        <!-- Profile Image or Initials -->
        <ng-container *ngIf="selectedUser.profile_image?.url; else checkLogo">
            <img [src]="selectedUser.profile_image.url" alt="User Image" class="avatar" />
        </ng-container>

        <ng-template #checkLogo>
            <ng-container *ngIf="selectedUser.logo?.url; else showInitials">
                <img [src]="selectedUser.logo.url" alt="User Logo" class="avatar" />
            </ng-container>
        </ng-template>

        <ng-template #showInitials>
            <div class="fallback-avatar">
                {{ getInitials(selectedUser.name) }}
            </div>
        </ng-template>

        <!-- User Name and Email -->
        <div class="user-details">
            <a style="cursor: pointer;" (click)="goToDetails(selectedUser)">
                <h6 class="user-name-detail">{{ selectedUser?.name }}</h6>
            </a>

            <!-- <h6 class="user-name" style="cursor: pointer;" (click)="goToDetails(selectedUser)">
                {{ selectedUser.company_name || selectedUser.name }}
            </h6> -->
            <p class="user-email">{{ selectedUser.email }}</p>
        </div>
    </div>

    <!-- Conditional Actions -->
    <div class="actions">
        <!-- If viewing people you follow -->
        <ng-container *ngIf="identifyName === 'Following'; else followerActions">
            <button mat-stroked-button color="warn" class="action-btn" (click)="unfollow(selectedUser)">
                <mat-icon style="transform: translateY(3px);">person_remove</mat-icon>
                <span>Unfollow</span>
            </button>
            <button mat-stroked-button color="primary" class="action-btn" (click)="sendMessage(selectedUser)">
                <mat-icon style="transform: translateY(3px);">send</mat-icon>
                <span>Send Message</span>
            </button>
        </ng-container>



        <ng-template #followerActions>
            <ng-container *ngIf="isMutual(selectedUser); else notMutual">
                <!-- If user is in both arrays => "Following" + "Send Message" -->
                <button mat-stroked-button color="accent" class="action-btn">
                    <mat-icon style="transform: translateY(3px);">check_circle</mat-icon>
                    <span>Following</span>
                </button>
                <button mat-stroked-button color="primary" class="action-btn" (click)="sendMessage(selectedUser)">
                    <mat-icon style="transform: translateY(3px);">send</mat-icon>
                    <span>Send Message</span>
                </button>
            </ng-container>
            <!-- Otherwise => "Follow" + "Send Message" -->
            <ng-template #notMutual>
                <button mat-stroked-button color="primary" class="action-btn" (click)="followBack(selectedUser)">
                    <mat-icon style="transform: translateY(3px);">person_add</mat-icon>
                    <span>Follow</span>
                </button>
                <button mat-stroked-button color="primary" class="action-btn" (click)="sendMessage(selectedUser)">
                    <mat-icon style="transform: translateY(3px);">send</mat-icon>
                    <span>Send Message</span>
                </button>
            </ng-template>
        </ng-template>


    </div>
</div>